import React from 'react';
import PropTypes from 'prop-types';

import {Box, TextField} from 'views/components';
import {translate} from 'views/module';

const TextInput = (props) => {
  const {questionData, value, onChange} = props;
  const resolvedMultiline = questionData?.multiline ?? false;
  const resolvedRows = questionData?.rows;
  const resolvedMinRows = questionData?.minRows ?? (resolvedMultiline ? 4 : undefined);
  const resolvedMaxRows = questionData?.maxRows ?? (resolvedMultiline ? 5 : undefined);

  return (
    <Box>
      <TextField
        fullWidth
        multiline={resolvedMultiline}
        rows={resolvedMultiline ? resolvedRows : undefined}
        minRows={resolvedMultiline ? resolvedMinRows : undefined}
        maxRows={resolvedMultiline ? resolvedMaxRows : undefined}
        placeholder={questionData?.placeholder || translate('form.Inputs.TextPlaceholder')}
        value={value}
        onChange={onChange}
        helperText={questionData.helpText}
        slotProps={{
          input: {
            sx: {
              borderRadius: '12px',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '150%',
            },
          },
        }}
      />
    </Box>
  );
};

TextInput.propTypes = {
  questionData: PropTypes.shape({
    placeholder: PropTypes.string,
    helpText: PropTypes.string,
    multiline: PropTypes.bool,
    rows: PropTypes.number,
    minRows: PropTypes.number,
    maxRows: PropTypes.number,
  }).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TextInput;
